import React, { useState } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import ModalComponent from "../modalComponent";
import { Button } from "react-bootstrap";

const PROJECT_LIST = [
  {
    id: "0",
    title: "HDFC Bank Mobile Banking App",
    category: "Banking and Finance",
    techStack: "React Native, Redux, Redux-Saga, Firebase, Secure Storage",
    projectDate: "April 2023 onwards",
    projectUrl: "apps.apple.com/in/app/hdfc-bank-app-early-access/id6504402552",
    image: "HDFC_App2.webp",
    description:
      "A Mobile Banking application targetting wide user base built ensuring security and scalability while delivering high performance, interactive user experience. Led frontend teams of Deposit, Profile and Mutual Funds modules, ensuring seamless integration with backend services and adherence to best practices in mobile app development.",
  },
  {
    id: "1",
    title: "Juno Dating App",
    category: "Dating and Social",
    techStack:
      "React, React Native, Firebase, Push Notifications, Real-time Chat",
    projectDate: "February 2023 to June 2023",
    projectUrl: "apps.apple.com/us/app/juno-dating/id1582585894",
    image: "Juno1.png",
    description:
      "A Dating app with Intelligent Matchmaking & Real-Time Interactions. Developed a feature-rich dating app that focused on finding the right match based on location, habits, interests, social and financial factors. The app delivered a visually appealing UI, engaging interactions, and real-time communication features for an enhanced user experience.",
  },
  {
    id: "3",
    title: "Dynafios",
    category: "Healthcare, Time tracking, Billing management",
    techStack: "React Native, Redux, Biometric Authentication, Geolocation",
    projectDate: "March 2022 to January 2023",
    projectUrl: "apps.apple.com/us/app/dynafios/id657793782",
    image: "Dynafios1.webp",
    description:
      "A physician billing management app for Hospitals that streamlined work hour logging, approvals, and billing processing for hospitals and medical professionals. The app ensured accuracy, efficiency, and compliance in tracking physician activities.",
  },
  {
    id: "4",
    title: "Air-Crews",
    category: "Aviation, Crew Management",
    techStack: "React Native, Redux, Firebase, Offline Support",
    projectDate: "April 2022 to August 2022",
    projectUrl: "biz4solutions.com/casestudy/aircraftcrews/",
    image: "airCrews1.png",
    description:
      "An Aviation Crew Management app that streamlined crew management for airlines, ensuring compliance with aviation regulations and enhancing operational efficiency. The app provided features for crew scheduling, duty tracking, and regulatory compliance.",
  },
  {
    id: "5",
    title: "Food Dining",
    category: "Inventory Management",
    techStack: "Next.js, React, Redux, Firebase, Node.js, Hapi",
    projectDate: "August 2024 to June 2025",
    projectUrl: "biz4solutions.com/casestudy/fooddining/",
    image: "FoodDining1.webp",
    description:
      "A Meals and food inventory management for old age homes. Included a Kiosk app to be placed in Old age homes and inventory management dashboard",
  },
  {
    id: "6",
    title: "JohnHancock | Data migration",
    category: "Data Migration, Insurance",
    techStack: "COBOL, Mainframe, Data Migration, SQL, DB2, JCL",
    projectDate: "January 2019 to October 2019",
    image: "JohnHancock1.jpg",
    description:
      "A data migration project for John Hancock, a leading insurance company. The project involved migrating data from legacy systems to modern platforms, ensuring data integrity and compliance with industry standards. The migration process was executed with minimal downtime and disruption to business operations.",
  },
  {
    id: "7",
    title: "Whitehat Jr",
    category: "Ed Tech, Online Learning",
    techStack: "React, WhereBy, Twilio, Firebase, React Native, Python",
    projectDate: "January 2019 to October 2019",
    image: "WhiteHat_Jr1.webp",
    description:
      "A web portal for live one to one teaching sessions built in React - NextJs. The platform provided a seamless experience for students and teachers, enabling real-time interactions and effective learning outcomes. The project involved integrating video conferencing, chat, and other interactive features to enhance the online learning experience.",
  },
  {
    id: "8",
    title: "Personal Portfolio Website.",
    category: "Personal Project",
    techStack: "React JS, Bootstrap, HTML, CSS",
    projectDate: "19 Dec, 2021",
    projectUrl: "kunalkarnik.com",
    image: "portfolio_screenshot.jpg",
    description:
      "A personal portfolio website built using React JS. This site is going to be hub for all I have done and all I am about to do. Basically a life and work showcase. Checkout the URL for more information.",
  },
];

const Projects = () => {
  const [openModalId, setOpenModalId] = useState(null);

  const closeModal = () => {
    setOpenModalId(null);
  };

  const renderProject = (project) => {
    const openModal = () => {
      setOpenModalId(project.id);
    };
    return (
      <div style={{ padding: "5px" }} key={project.id}>
        <div className="portfolio-wrap">
          <img
            src={require(`../../assets/img/portfolio/${project.image}`)}
            alt=""
            style={{ maxWidth: "100%", border: "solid #363636" }}
          />
          <div className="portfolio-info">
            <h4>{project.title}</h4>
            <p>{project.techStack}</p>
            <div className="portfolio-links">
              <Button className="link-btn" onClick={openModal}>
                <i className="bx bx-plus" />
                <span title="Know More" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section id="portfolio" className="portfolio section-bg">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Portfolio</h2>
          <p>Below are some projects I've been working on lately.</p>
        </div>
        {/* Uncomment the following lines if you want to add filters for projects */}
        {/* <div className="row">
          <div
            className="col-lg-12 d-flex justify-content-center"
            data-aos="fade-up"
            data-aos-delay={100}
          >
            <ul id="portfolio-flters">
              <li data-filter="*" className="filter-active">
                All
              </li>
              <li data-filter=".filter-app">App</li>
              <li data-filter=".filter-card">Card</li>
              <li data-filter=".filter-web">Web</li>
            </ul>
          </div>
        </div> */}
        <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}>
          <Masonry disableImagesLoaded={false} updateOnEachImageLoad={false}>
            {PROJECT_LIST.map(renderProject)}
          </Masonry>
        </ResponsiveMasonry>
        <ModalComponent
          data={PROJECT_LIST.find((project) => project.id === openModalId)}
          show={!!openModalId}
          onHide={closeModal}
        />
      </div>
    </section>
  );
};

export default Projects;
